import { useState, useEffect } from 'react';
import onlineStatusServiceDefault, { onlineStatusService as onlineStatusServiceNamed, MissedConnectionRequest } from '../services/onlineStatusService';

const onlineStatusService = onlineStatusServiceNamed ?? onlineStatusServiceDefault;

export const useMissedConnectionRequests = () => {
  const [missedRequests, setMissedRequests] = useState<MissedConnectionRequest[]>([]);
  const [hasMissedRequests, setHasMissedRequests] = useState(false);

  useEffect(() => {
    const safeGetMissedRequests = (): MissedConnectionRequest[] => {
      if (!onlineStatusService || typeof onlineStatusService.getMissedConnectionRequests !== 'function') {
        return [];
      }
      return onlineStatusService.getMissedConnectionRequests();
    };

    // Get initial missed requests
    const initialRequests = safeGetMissedRequests();
    setMissedRequests(initialRequests);
    setHasMissedRequests(initialRequests.length > 0);

    // Set up interval to check for missed requests
    const interval = setInterval(() => {
      const currentRequests = safeGetMissedRequests();
      setMissedRequests(currentRequests);
      setHasMissedRequests(currentRequests.length > 0);
    }, 1000); // Check every second

    return () => {
      clearInterval(interval);
    };
  }, []);

  const clearMissedRequests = () => {
    if (onlineStatusService && typeof onlineStatusService.clearMissedConnectionRequests === 'function') {
      onlineStatusService.clearMissedConnectionRequests();
    }
    setMissedRequests([]);
    setHasMissedRequests(false);
  };

  return {
    missedRequests,
    hasMissedRequests,
    clearMissedRequests
  };
};



















